import React, { useEffect, useState }  from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import { CsvButton,downloadCSV } from '../../../service/CsvButton';
import { GPAP_Button_light } from '../../../../gpap-lib/Button_Collection';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Typography from '@mui/material/Typography';
import "../../components/custom_material_ui_like.css";

import Loading from "../../components/LoadingTable";

const BasicView = (props) => {

    let reactTable = React.createRef();
    
    const [filterCsv, setFilterCsv] = useState(false);

    const onTableViewChange = () => {
        // Handles Filter Change on Table
        setFilterCsv(true);
    }

    // Get CSV Data
    const getCsvData = () => {
        //Build data for CSV
        const currentData = filterCsv ?  reactTable.getResolvedState().sortedData : props.data;
        //Loop data
        let data = [];
        currentData.forEach((item) => {
            let row = {};
            props.headers.forEach((header) => {
                if (typeof item[header.key] === "boolean") row[header.key] = item[header.key].toString();
                else row[header.key] = item[header.key];
            });
            data.push(row);
        });
        // Call CSV File
        let today = new Date().toISOString().slice(0, 10);
        downloadCSV(data,props.headers,`${today}_file_list.csv`)
    }

    // Set component rendering
    const defaultPageSize = "defaultPageSize" in props ? props.defaultPageSize : 100;
    // Initialize OnFetchData Function
    let loadDataProps = {};
    if (props.onFetchData !== undefined) loadDataProps["onFetchData"] = props.onFetchData;
    // Go Back
    let backHref = "#/management";
    if(props.goBack !== undefined) backHref = props.goBack;

    return ( 
        <div className={"mainContent"}>
            {props.title !== undefined ? 
                    <Typography variant={"h5"} align={"center"}>{ props.title } </Typography>
                : 
                    null    
            }                
            
            <GPAP_Button_light href={backHref}  startIcon={<ArrowBackIcon />}>
                Back
            </GPAP_Button_light>
            
            <CsvButton getCsvData={getCsvData} />
            
            <ReactTable
                data={props.data}
                filterable
                columns={props.columns}
                defaultPageSize = {defaultPageSize}
                pageSizeOptions = {[10,20,50,100, 200, 300]}
                getTdProps={props.onRowClick}
                ref={(r) => reactTable = r}
                onFilteredChange={onTableViewChange}
                className="-striped -highlight"
                style={{
                    height: 500
                }}
                loading={props.loading}
                LoadingComponent={Loading}
                {...loadDataProps}
            >
                {/* React Table Functional Rendering for printing number of record
                    Passing a function as the child of ReactTable called with the fully resolved state of the table
                    makeTable function which returns the standard table component and the instance of the component*/}
                {(state, makeTable, instance) => {
                    //Get Counts of Table Rows
                    let recordsInfoText = "";
                    const { filtered, pageRows, pageSize, sortedData, page } = state;
                    //Count Records
                    if (sortedData && sortedData.length > 0) {
                        let isFiltered = filtered.length > 0;
                        let totalRecords = sortedData.length;
                        let recordsCountFrom = page * pageSize + 1;
                        let recordsCountTo = recordsCountFrom + pageRows.length - 1;

                        if (isFiltered)
                            recordsInfoText = `${recordsCountFrom}-${recordsCountTo} of ${totalRecords} filtered records`;
                        else
                            recordsInfoText = `${recordsCountFrom}-${recordsCountTo} of ${totalRecords} records`;
                    }
                    else recordsInfoText = "No records";
                    //Render JSX
                    return (
                        <div className="main-grid">
                            <div className="above-table text-right">
                                <div className="col-sm-12">
                                    <span className="records-info">{recordsInfoText}</span>
                                </div>
                            </div>
                            {makeTable()}
                        </div>
                    );
                }}
            </ReactTable>
        </div>
    );
}

export default BasicView;
